import { useState } from 'react';
import { AMPLIFY_USERNAME_ERROR } from '../../constants/errors';
import { Copy } from '../../copy/Copy';
import { useAuth } from '../../hooks/useAuth/useAuth';
import { centerText16pxMarginSx } from '../../styles/Global.style';
import { HelperLink } from '../HelperLink/HelperLink';
import { Text } from '../Text/Text';

export const SendConfirmationCode = ({
  userEmail,
  handleError,
  resetError,
}) => {
  const [isSentConfirmationCode, setIsSentConfirmationCode] = useState(false);
  const { resendConfirmationCode } = useAuth();

  const resetIsSentConfirmationCode = () => {
    setTimeout(() => {
      setIsSentConfirmationCode(false);
    }, 3000);
  };

  const handleResendCode = async (email) => {
    try {
      await resendConfirmationCode(email);
      setIsSentConfirmationCode(true);
      resetIsSentConfirmationCode();
    } catch (err) {
      handleError(
        err.message === AMPLIFY_USERNAME_ERROR
          ? Copy.generate('Errors.enterEmailForCode')
          : err.message,
      );
      resetError();
    }
  };

  return (
    <>
      {!isSentConfirmationCode && (
        <HelperLink
          to="#"
          textIdentifier="Links.resendCode"
          linkText={Copy.generate('Global.resendCode')}
          onClick={() => handleResendCode(userEmail)}
          sx={centerText16pxMarginSx}
        />
      )}

      {isSentConfirmationCode && (
        <Text
          text={Copy.generate('SendConfirmationCode.codeSent')}
          sx={centerText16pxMarginSx}
        />
      )}
    </>
  );
};
